import React, { forwardRef }  from "react";

import { IconButton, SvgIconProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";

type ButtonIconProps = {
  onClick: () => void;
  color: "primary" | "secondary" | "info" | "error";
  size: string | number;
  Icon: React.ComponentType<SvgIconProps>;
  disabled?: boolean;
  tooltip?: string;
};

const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconProps>(
  ({
  onClick,
  color,
  size,
  Icon,
  disabled,
  tooltip,
}, ref) => {
  const theme = useTheme();

  return (
    <HelpBox title={tooltip} placement="bottom">
      <IconButton
        ref={ref}
        color="primary"
        disabled={disabled}
        onClick={onClick}
        sx={{
          color: theme.palette[color].contrastText,
          // backgroundColor: theme.palette[color].main,
          backgroundColor: theme.palette.background.default,
          "&:hover": {
            // backgroundColor: theme.palette[color].dark
            backgroundColor: theme.palette.background.default,
            borderColor: theme.palette[color].main,
          },
          borderRadius: "4px",
          border: 1,
          borderColor: theme.palette.divider,
          boxShadow: theme.shadows[2],
          height: size,
          width: size,
        }}
      >
        <Icon fontSize="small" color={disabled ? "disabled" : color} />
      </IconButton>
    </HelpBox>
  );
});

export default ButtonIcon;
